import { Pipe, PipeTransform } from '@angular/core';
import { AGENDA_STATUS_COLORS, AgendaStatus } from '../utils/agenda-utils';

@Pipe({
  name: 'agendaStatusStyle',
  pure: true
})
export class AgendaStatusStylePipe implements PipeTransform {

  transform(status: string) {
    const colors = AGENDA_STATUS_COLORS[status as AgendaStatus];
    return colors
      ? {
        backgroundColor: colors.background,
        borderColor: colors.border,
        color: colors.text
      }
      : {
        backgroundColor: '#E0E0E0',
        borderColor: '#BDBDBD',
        color: '#424242'
      };
  }
}
